export const COUNTRY_LABELS = {
  IN: "India",
  SG: "Singapore",
  MY: "Malaysia",
  ID: "Indonesia",
  TH: "Thailand",
  PH: "Philippines",
  VN: "Vietnam",
};

export const STAGE_LABELS = {
  regular: "Regular periods",
  irregular: "Irregular periods",
  stopped_12m: "No period for 12 months or more",
};

export const LAB_LABELS = {
  ferritin: "Ferritin",
  hb: "Haemoglobin",
  b12: "Vitamin B12",
  vitd: "Vitamin D",
  calcium_serum: "Serum calcium",
  egfr: "eGFR",
  tsh: "TSH",
};

export const LAB_VALUE_LABELS = {
  very_low: "Very low",
  low: "Low",
  normal: "Normal",
  high: "High",
  abnormal: "Abnormal",
};

export const EMPTY_PROFILE = {
  country: "",
  age: 44,
  weight_kg: 65,
  stage: "regular",
};